export const ORDER_CREATION_REDIRECTS = {
    POST_ORDER_PAGE: 'post_order_page',
    CHECKOUT_PAGE: 'checkout_page',
};
